<template>
  <div class="title">
    <div class="text">{{ ch }}</div>
    <img class="title-bg" :src="bgImg" />
  </div>
</template>
span
<script>
export default {
  name: "Title",
  props: {
    ch: {
      type: String,
      default: "",
    },
    bgImg: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
//title begin
.title {
  width: 100%;
  .text {
    display: none;
  }
  .title-bg {
    display: none;
  }
}
@media screen and (max-width: 992px) {
  .title {
    margin-bottom: 22px;
    .text {
      display: none;
    }
    .title-bg {
      display: block;
      width: auto;
      height: 56px;
      margin-left: 34px;
    }
  }
}
@media screen and (min-width: 992px) {
  .title {
    padding-bottom: 22px;
    .text {
      display: block;
      font-size: $font-xxxxl;
      font-family: Microsoft YaHei-Bold;
      font-weight: bold;
      color: #151e26;
      line-height: 1.2;
    }
    .title-bg {
      display: none;
    }
  }
}
//title end
</style>
